/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Before_Unload_ConfirmInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to leave?" |
*
* @param {Creator_Before_Unload_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_before_unload_confirm = /** @type {((inputs?: Creator_Before_Unload_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Before_Unload_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Etes-vous sur de vouloir quitter ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bist du sicher, dass du gehen willst?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sei sicuro di voler uscire?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены, что хотите уйти?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Estás seguro que deseas salir?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("你确定要离开吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("本当に退出しますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आपकी वाकई छोड़ने की इच्छा है?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza de que deseja ir embora?")
	return /** @type {LocalizedString} */ ("Are you sure you want to leave?")
});